import React, { FunctionComponent } from 'react';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import useStyles from './style';

export interface DialogCloseProps extends IconButtonProps {
    id: string;
    onClose: () => void;
}

const DialogClose: FunctionComponent<DialogCloseProps> = (props: DialogCloseProps) => {
    const classes = useStyles();
    const { className, onClose, ...rest } = props;
    const classNameMerged = clsx({ [classes.closeButton]: true }, className);

    return (
        <IconButton size="small" onClick={onClose} className={classNameMerged} {...rest}>
            <CloseIcon />
        </IconButton>
    );
};

export default DialogClose;
